module.exports = __webpack_public_path__ + "static/media/copy-solid.2508d4eb.svg";